module.exports = __webpack_public_path__ + "static/media/SUPERFICIE_No.12_.e5b58bf9.pdf";